import { createContext, useContext } from 'react';

export type WalletAvailability = {
  googlePay: boolean;
  applePay: boolean;
};

export const WalletAvailabilityContext = createContext<WalletAvailability>({
  googlePay: false,
  applePay: false,
});

export const useWalletAvailability = () =>
  useContext(WalletAvailabilityContext);
